
var url = process.env.REACT_APP_API_ENDPOINT + '/rest';




export function dummyRestKall(bevisId) {
  return getData(`dummy`, bevisId);
}

export function getHund(hundId) {
    return getData(`hund?id=${hundId}&validerAdgang=false`, false);
}

export function getForfedre(hundId, bevisId) {
    return getData(`hund/forfedre?hundId=${hundId}`, bevisId);
}

export function getHundOgLeggTilSisteHunder(hundId) {
   return getData(`hund?id=${hundId}&historie=true`);
}

export function getHundByBevisId(bevisId) {
    return getData(`hund/id/${bevisId}`);
}


export function getStamtavleTre(hundId, antallGenerasjonerInnavlsberegning, antallGenerasjonerStamtavle, fiktiv, bevisId) {
    return getData(`hund/stamtavleTre?hundId=${hundId}&antallGenerasjonerInnavlsberegning=${antallGenerasjonerInnavlsberegning}&antallGenerasjonerStamtavle=${antallGenerasjonerStamtavle}&fiktiv=${fiktiv}`, bevisId);
}


export function getHundProfilBilde(hundId, bevisId) {
    return getData(`hund/profilBilde?hundId=${hundId}`, bevisId);
}

export function getOppdretterProfilBilde(hundId, bevisId) {
    return getData(`oppdretterProfilBilde?hundId=${hundId}`, bevisId);
}


export function getSoeskenSammeKull(hundId, bevisId) {
   return getData(`hund/soeskenSammeKull?hundId=${hundId}`, bevisId);
}

export function getHelSoesken(hundId, bevisId) {
    return getData(`hund/helSoesken?hundId=${hundId}`, bevisId);
}

export function getKullSammeFar(hundId, bevisId) {
    return getData(`hund/soeskenSammeFar?hundId=${hundId}`, bevisId);
}

export function getKullSammeMor(hundId, bevisId) {
    return getData(`hund/soeskenSammeMor?hundId=${hundId}`, bevisId);
}

export function getBarnebarn(hundId, bevisId) {
    return getData(`hund/barnebarn?hundId=${hundId}`, bevisId);
}

export function getAvkom(hundId, bevisId) {
    return getData(`hund/avkom?hundId=${hundId}`, bevisId);
}

export function getUtstillingsresultater(hundId, bevisId) {
    return getData(`hund/utstillingResultater?hundId=${hundId}`, bevisId);
}

export function getUtenlandskeUtstillingResultater(hundId, bevisId) {
    return getData(`hund/utenlandskeResultater?hundId=${hundId}&utstilling=true`, bevisId);
}

export function getUtenlandskeProeveResultater(hundId, bevisId) {
    return getData(`hund/utenlandskeResultater?hundId=${hundId}&utstilling=false`, bevisId);
}


export function getEksterioerGodkjennelseResultater(hundId, bevisId) {
    return getData(`hund/eksterioerGodkjennelseResultater?hundId=${hundId}`, bevisId);
}

export function getProeveresultater(hundId, bevisId) {
    return getData(`hund/proeveresultater?hundId=${hundId}`, bevisId);
}

export function getOyeEcvoUndersoekelser(hundId, bevisId) {
    return getData(`hund/oyeEcvoUndersoekelser?hundId=${hundId}`, bevisId);
}

export function getRyggIndeksHistorie(hundId, bevisId) {
    return getData(`hund/rygIndexHistorie?hundId=${hundId}`, bevisId);
}

export function getHdIndeksHistorie(hundId, bevisId) {
    return getData(`hund/hdIndexHistorie?hundId=${hundId}`, bevisId);
}

export function getMentalbeskrivelse(hundId, bevisId) {
    return getData(`hund/mentalbeskrivelse?hundId=${hundId}`, bevisId);
}

export function getSunnhetUndersoekelser(hundId, uoffsielleResultater, bevisId) {
    return getData(`hund/sunnhetUndersoekelser?hundId=${hundId}&uoffsielleResultater=${uoffsielleResultater}`, bevisId);
}

export function getAvkomRoentgenStatistikk(hundId, bevisId) {
    return getData(`hund/avkomRoentgenStatistikk?hundId=${hundId}`, bevisId);
}

export function getBarnebarmRoentgenStatistikk(hundId, bevisId) {
    return getData(`hund/barnebarnRoentgenStatistikk?hundId=${hundId}`, bevisId);
}

export function getRaseRoentgenStatistikk(hundId, bevisId) {
    return getData(`hund/raseRoentgenStatistikk?hundId=${hundId}`, bevisId);
}

export function getKullOppdretter(hundId, bevisId) {
    return getData(`hund/kullOppdretter?hundId=${hundId}`, bevisId);
}

export function getSisteHunder() {
    return getData(`sisteHunder`);
}

export function getFavorittHunder() {
    return getData(`favorittHunder`);
}

export function getMineHunder() {
    return getData(`mineHunder`);
}

export function getPersonIdGyldigBruker() {
    return getData(`personIdGyldigBruker`);
}

export function isUserAuthenticated() {
    return getData(`userAuthenticated`);
}

export function postForm(action, formData) {
    return new Promise((resolve, reject) => {
        window.fetch(process.env.REACT_APP_API_ENDPOINT + `/rest/${action}`, {
            credentials: "same-origin",
            method: "POST",
            body: formData
        })
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 0) {
                        throw Error("Tjek om du er på internettet og prøv igen");
                    }
                    else if (response.status === 500) {
                        return response.json() // return the result of the inner promise, which is an error
                            .then((json) => {
                                throw new Error(json);
                            });
                        //console.log(response.json());
                    }
                    else {
                        throw Error("Det er sket en fejl. Prøv igen.");
                    }
                }
            })
            .then(resolve)
            .catch(reject);
    });
}



export function soekHund(query, antall) {
    var req = "soek?query=" + query;

    if (antall !== null) {
        req += "&antall=" + antall;
    }
    return new Promise((resolve, reject) => {
        window.fetch(process.env.REACT_APP_REST_SEARCH_API_ENDPOINT + `/rest/${req}`, {credentials: 'same-origin'})
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 0) {
                        throw Error("Tjek om du er på internettet og prøv igen");
                    }
                    else if (response.status === 500) {
                        return response.json() // return the result of the inner promise, which is an error
                            .then((json) => {
                                if (json.redirectUrl){
                                    window.location = json.redirectUrl;
                                    return null;
                                }
                                else
                                    throw new Error(json);
                            });
                    }
                    else if (response.status === 403) {
                        throw Error("403");
                    }
                    else {
                        //   console.log("Request:" + req);
                        throw Error("Det er sket en fejl. Prøv igen.");
                    }
                }
                else {
                    //console.log("Request: " + req);
                    return response.json();
                }
            })
            .then(resolve)
            .catch(reject);
    });
}



function getData(req, bevisId) {
    return new Promise((resolve, reject) => {
        const headers = {};
        if (bevisId) {
            headers['X-Bevis-Request'] = bevisId;
        }
        window.fetch(process.env.REACT_APP_API_ENDPOINT + `/rest/${req}`, {
                credentials: 'same-origin',
                headers: headers
            })
            .then((response) => {
                    if (!response.ok) {
                        if (response.status === 0) {
                            throw Error("Tjek om du er på internettet og prøv igen");
                        }
                        else if (response.status === 500) {
                            return response.json() // return the result of the inner promise, which is an error
                                .then((json) => {
                                    if (json.redirectUrl){
                                        window.location = json.redirectUrl;
                                        return null;
                                    }
                                    else {
                                        throw new Error(json);
                                    }
                                });
                        }
                        else if (response.status === 403) {
                            throw Error("403");
                        }
                        else {
                         //   console.log("Request:" + req);
                            throw Error("Det er sket en fejl. Prøv igen.");
                        }
                    }
                    else {
                        //console.log("Request: " + req);

                        return response.json();
                    }
                })
            .then(resolve)
            .catch(reject);
    });
}

